export default __webpack_public_path__ + "static/SRUS RT80 - Especification Del Producto y Datos Técnicos-dc3df1cef6596716a2e8e4b18a221cae.pdf";